module.exports={
  "Description": "RE : 974NN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^974[0-9]{2}$",
  "TestData": {
    "Valid": [
      "97400",
      "97490"
    ],
    "Invalid": [
      "9742",
      "974999",
	  "97390",
	  "097490"
    ]
  }
}